import { NoteTemplateManager } from '@/components/NoteTemplateManager';
import { TEMPLATE_VARIABLES } from '@/lib/note-templates';

export default function AccountNoteTemplatesPage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-lg font-semibold text-foreground">Note templates</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Canned ticket notes you can insert from any ticket, then edit before sending.
        </p>
      </div>

      <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
        <NoteTemplateManager/>
      </div>

      <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
        <h3 className="text-[13px] font-semibold text-foreground">Available variables</h3>
        <p className="mt-0.5 text-[12px] text-muted-foreground">
          Filled in from the ticket at the moment you insert the template. Add a fallback with a
          pipe — <code className="rounded bg-muted px-1">{'{{contact.first_name|there}}'}</code> — for
          tickets where the value is missing.
        </p>
        <dl className="mt-3 grid gap-x-6 gap-y-1.5 sm:grid-cols-2">
          {TEMPLATE_VARIABLES.map((v) => (
            <div key={v.token} className="flex items-baseline justify-between gap-3 border-b border-border/60 py-1">
              <dt className="text-[12px] text-muted-foreground">{v.label}</dt>
              <dd>
                <code className="rounded bg-muted px-1 text-[11.5px] text-foreground">{`{{${v.token}}}`}</code>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
